import React from 'react';
import { 
  CheckCircle, 
  ArrowRight, 
  Cloud, 
  Settings, 
  Zap, 
} from 'lucide-react';
import Reveal from './Reveal';

const Services: React.FC = () => {
  const services = [
    {
      icon: <Settings className="w-8 h-8" />,
      title: 'Consultoria y Gestión Tecnologica',
      description: 'Modelo operativo de IT con servicios gestionados de infraestructura, bases de datos y entornos virtuales.',
      features: [
        'Modelo Operativo y Servicio Gestionado de IT',
        'Arquitectura Empresarial  Gestión, Soporte y Mantenimiento Suite Productos Red Hat (OCP, OCP Virt, Ansible, RHEL)',
        'Gestión, Soporte y Mantenimiento Plataformas Microservicios OpenSource (Kubernetes)',
        'Gestión, Soporte y Mantenimiento Suite Productos Microsoft O365',
        'Transformación Digital'
      ],
    },
    {
      icon: <Cloud className="w-8 h-8" />,
      title: 'Cloud Services',
      description: 'Servicios completos de migración, gestión y optimización en la nube para AWS, Azure y Huawei.',
      features: [
        'Diseños de Arquitecturas. (AWS, GCP, Azure, Huawei)',
        'Migración de Infraestructuras',
        'Entrega e Integración Continua (CI/CD)'
      ],
    },
    {
      icon: <Zap className="w-8 h-8" />,
      title: 'Ingenieria de Plataforma',
      description: 'Implementación de prácticas DevOps y DevSecOps con herramientas de automatización y monitoreo.',
      features: [
        'Servicios DevOps y DevSecOps',
        'Monitoreo y Observabilidad (Stack de Observalidad propio, SaaS)',
        'Servicio de Backups'
      ],
    }
  ];

  return (
    <section id="services" className="section-padding bg-surface relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 right-20 w-64 h-64 bg-accent-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-20 left-20 w-48 h-48 bg-accent-600/5 rounded-full blur-3xl" />
      </div>

      <div className="container-custom relative z-10">
        <Reveal className="text-center mb-16">
          <div className="section-badge">
            <CheckCircle className="w-4 h-4 mr-2" />
            Nuestros Servicios
          </div>

          <h2 className="section-title">
            Nuestros
            <span className="text-accent-400 block">Servicios</span>
          </h2>

          <p className="section-subtitle max-w-4xl">
            Ofrecemos una gama completa de servicios tecnológicos diseñados para optimizar
            tu infraestructura cloud, automatizar procesos y reducir costos operativos.
          </p>
        </Reveal>

        <div className="grid lg:grid-cols-3 gap-8 mb-20">
          {services.map((service, index) => (
            <Reveal key={service.title} delay={index * 0.1}>
              <div className="group h-full">
                <div className="surface-card p-8 h-full hover:border-accent-500/40 transition-all duration-300 card-hover">
                  <div className="w-16 h-16 bg-accent-500/15 border border-accent-500/30 text-accent-400 rounded-2xl flex items-center justify-center mb-6 transition-transform duration-300 group-hover:scale-105">
                    {service.icon}
                  </div>

                  <div className="space-y-4">
                    <h3 className="text-2xl font-bold text-white group-hover:text-accent-400 transition-colors duration-300">
                      {service.title}
                    </h3>

                    <p className="text-gray-400 leading-relaxed">
                      {service.description}
                    </p>

                    <ul className="space-y-2">
                      {service.features.map((feature) => (
                        <li key={feature} className="flex items-start text-gray-400">
                          <CheckCircle className="w-4 h-4 text-accent-500 mr-2 flex-shrink-0 mt-1" />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="bg-gradient-to-r from-surface-overlay via-secondary-900 to-surface-overlay border border-accent-500/25 rounded-3xl p-12 md:p-16 text-center relative overflow-hidden">
            <div className="absolute inset-0 bg-accent-500/5" />
            <div className="relative z-10">
              <h3 className="text-3xl md:text-5xl font-bold text-white mb-6">
                ¿Listo para Transformar tu Infraestructura?
              </h3>
              <p className="text-lg md:text-xl text-gray-400 mb-8 max-w-3xl mx-auto">
                Descubre cómo nuestras soluciones cloud y DevOps pueden optimizar
                tu infraestructura, reducir costos y mejorar la eficiencia operativa.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="#contact" className="btn-primary py-4 px-8 text-lg inline-flex items-center justify-center">
                  Contactanos
                  <ArrowRight className="w-5 h-5 ml-2" />
                </a>

                <a href="#technology" className="btn-outline py-4 px-8 text-lg inline-flex items-center justify-center">
                  Ver Tecnología
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Services;
